'use-strict'

function faqActions() {

	$('[js-faq-question]').on('click', function() {
		onClickFaqQuestion( $(this) );
	});
	
}
function onClickFaqQuestion( target ) {

	if ( target.hasClass('faq__question--active') ) {

		target
			.removeClass('faq__question--active')
			.siblings('[js-faq-answer]').slideUp(300);
		
	} else {

		if ( $('.faq__question--active').length ) {

			$('.faq__question--active')
				.removeClass('faq__question--active')
				.siblings('[js-faq-answer]').slideUp(300);

		}

		target
			.addClass('faq__question--active')
			.siblings('[js-faq-answer]').slideDown(300);
		
	}
	
}

export {
	faqActions,
};